
function Blog() {
    return (
        <div class="container">
  <div class="row">
    <div class="col-2">
    </div>
    <div class="col-sm">
        {/* blog1 */}
        <h1 class = "p-4">Blog</h1>
        <h4 class = "text-left mb-4">30 Javascript Array Methods: A Cheat Sheet for Developers</h4>
        <a href="https://medium.com/@silviyafrontenddev/30-javascript-array-methods-a-cheat-sheet-for-developers-98fc4dd33957" target="blank">
        <img src = "blog1.jpg" alt = "img" width= "100%" height={300}></img>
        </a>
        <p class = "text-left mt-2">JavaScript, an array is a data structure that contains a list of elements that store multiple values in a single.....</p>
        <p class = "text-left mt-2">by @Silviyadev</p>

        {/* blog2 */}
        <h4 class = "text-left mb-4 mt-4">Polyfill of forEach, map, filter and reduce in Javascript ES6</h4>
        <a href="https://medium.com/@silviyafrontenddev/polyfill-of-foreach-map-filter-and-reduce-in-javascript-es6-1f9d81501ee1" target="blank">
        <img src = "blog2.jpg" alt = "img" width= "100%" height={300}></img>
        </a>
        <p class = "text-left mt-2">A piece of code that provides native support to the older browsers that do not have the support of modern functionalities of javascript.....</p>
        <p class = "text-left mt-2">by @Silviyadev</p>

        {/* blog3 */}
        <h4 class = "text-left mb-4 mt-4">Getting Started with React Hooks</h4>
        <a href="https://medium.com/@silviyafrontenddev/30-javascript-array-methods-a-cheat-sheet-for-developers-98fc4dd33957" target="blank">
        <img src = "reactHooks.jpg" alt = "img" width= "100%" height={300}></img>
        </a>
        <p class = "text-left mt-2">Hooks are a new addition in React 16.8. They let you use state and other React features without writing a class......</p>
        <p class = "text-left mt-2">by @Silviyadev</p>

        {/* blog4
        <h4 class = "text-left mb-4 mt-4">30 Javascript Array Methods: A Cheat Sheet for Developers</h4>
        <a href="https://medium.com/@silviyafrontenddev/30-javascript-array-methods-a-cheat-sheet-for-developers-98fc4dd33957" target="blank">
        <img src = "blog1.jpg" alt = "img" width= "100%" height={300}></img>
        </a>
        <p class = "text-left mt-2">JavaScript, an array is a data structure that contains a list of elements that store multiple values in a single.....</p>
        <p class = "text-left mt-2">by @Silviyadev</p> */}
    </div>
    <div class="col-2">
    </div>
  </div>
</div>
    )
}

export default Blog;